(function() {
    // 1. DOM ELEMENTS
    const get = (id) => document.getElementById(id);
    const canvas = get('gameCanvas');
    if (!canvas) return;
    const ctx = canvas.getContext('2d');

    const UI = {
        mobileScore: get('mobile-score'),
        desktopScore: get('desktop-score'),
        startOverlay: get('start-overlay'),
        startText: get('start-overlay')?.querySelector('p'),
        gameOverModal: get('gameOverModal'),
        finalScore: get('finalScore'),
        nameInput: get('playerName'),
        submitBtn: get('submitScoreBtn'),
        restartBtn: get('restartBtn'),
        fullScreenBtn: get('fullscreen-btn'),
        fullScreenContainer: get('fullscreen-btn-container'),
        mainContainer: get('main-container'),
        cryingFrog: get('crying-frog'),
        unlockMsg: get('unlock-message'),
        music: get('background-music'),
        helpBtn: get('help-btn'),
        soundBtn: get('sound-btn'),
        helpModal: get('helpModal'),
        closeHelp: get('closeHelpBtn'),
        closeGameOver: get('closeGameOverBtn')
    };

    // 2. CONFIG & STATE
    const CFG = {
        GRAVITY: 0.7, JUMP: -16, GROUND: 50, SPEED: 250,
        SPEED_INC: 30, MILESTONE: 40, HITBOX: 0.18, GLIDE: 0.5,
        W: 800, H: 400, MIN_GAP: 450, MAX_GAP: 650, HANG: 2.0,
        UNLOCK: 600, TRAIL: 6, POUND: 25, FRICTION: 0.96, BOUNCE: 0.6,
        SIZES: { FROG: 80, CAR: 80, DUMP: 70, CONE: 45, ROCK_MIN: 30, ROCK_MAX: 65 }
    };

    let state = {
        mode: 'waiting', score: 0, speed: CFG.SPEED, nextSpeed: CFG.MILESTONE,
        lastTime: 0, timer: 0, scaleX: 1, scaleY: 1,
        doubleJump: false, lastScore: -1, muted: true,
        inputHeld: false, actionTaken: false, touchY: 0
    };

    let player, obstacles = [], clouds, ground, looseBoard;
    
    // 3. ASSETS
    const createImg = (src, type) => {
        const img = new Image();
        img.src = src;
        if(type) img.obstacleType = type;
        return img;
    };

    const assets = {
        playerIdle: createImg('https://cdn.shopify.com/s/files/1/0588/8032/7851/files/FrogPix-Idle.png?v=1763925088'),
        playerJump: createImg('https://cdn.shopify.com/s/files/1/0588/8032/7851/files/FrogPix-Jump.png?v=1763925132'),
        playerDead: createImg('https://cdn.shopify.com/s/files/1/0588/8032/7851/files/FrogPix-GameOver.png?v=1763925222'),
        board: createImg('https://cdn.shopify.com/s/files/1/0588/8032/7851/files/SkateboardPix.png?v=1763925202'),
        cloud: createImg('https://cdn.shopify.com/s/files/1/0588/8032/7851/files/Clouds.png?v=1750975456'),
        road: createImg('https://cdn.shopify.com/s/files/1/0588/8032/7851/files/Road.png?v=1750974756'),
        obstacles: [
            ...["https://cdn.shopify.com/s/files/1/0588/8032/7851/files/PixAssets2-08.png?v=1763962367", "https://cdn.shopify.com/s/files/1/0588/8032/7851/files/PixAssets2-09.png?v=1763962367", "https://cdn.shopify.com/s/files/1/0588/8032/7851/files/PixAssets2-15.png?v=1763962367", "https://cdn.shopify.com/s/files/1/0588/8032/7851/files/PixAssets2-16.png?v=1763962367"].map(s => createImg(s, 'rock')),
            ...["https://cdn.shopify.com/s/files/1/0588/8032/7851/files/PixAssets2-07.png?v=1763962367", "https://cdn.shopify.com/s/files/1/0588/8032/7851/files/PixAssets2-13.png?v=1763962367", "https://cdn.shopify.com/s/files/1/0588/8032/7851/files/PixAssets2-12.png?v=1763962367", "https://cdn.shopify.com/s/files/1/0588/8032/7851/files/PixAssets2-18.png?v=1763962367", "https://cdn.shopify.com/s/files/1/0588/8032/7851/files/PixAssets2-05.png?v=1763962367", "https://cdn.shopify.com/s/files/1/0588/8032/7851/files/PixAssets2-06.png?v=1763962367"].map(s => createImg(s, 'car')),
            ...["https://cdn.shopify.com/s/files/1/0588/8032/7851/files/PixAssets2-14.png?v=1763962367", "https://cdn.shopify.com/s/files/1/0588/8032/7851/files/PixAssets2-11.png?v=1763962367"].map(s => createImg(s, 'dumpster')),
            ...["https://cdn.shopify.com/s/files/1/0588/8032/7851/files/PixAssets2-10.png?v=1763962367"].map(s => createImg(s, 'cone'))
        ]
    };

    // 4. CLASSES
    class Skateboard {
        constructor(x, y) {
            this.w = 60; this.h = 20; this.x = x; this.y = y;
            this.vx = 8 + Math.random() * 5; this.vy = -12 - Math.random() * 5;
            this.rot = 0; this.rotSpd = (Math.random() - 0.5) * 0.5;
        }
        update(dt) {
            this.vy += CFG.GRAVITY * dt * 60;
            this.x += this.vx * dt * 60; this.y += this.vy * dt * 60;
            this.rot += this.rotSpd;
            const gY = CFG.H - CFG.GROUND - this.h;
            if (this.y > gY) {
                this.y = gY; this.vy *= -CFG.BOUNCE; this.vx *= 0.9; this.rotSpd *= 0.8;
            }
        }
        draw() {
            if (!assets.board.complete) return;
            ctx.save();
            ctx.translate((this.x + this.w/2)*state.scaleX, (this.y + this.h/2)*state.scaleY);
            ctx.rotate(this.rot);
            ctx.drawImage(assets.board, -this.w/2*state.scaleX, -this.h/2*state.scaleY, this.w*state.scaleX, this.h*state.scaleY);
            ctx.restore();
        }
    }

    class Player {
        constructor() {
            this.w = 80; this.h = 80; this.x = 50;
            this.y = CFG.H - CFG.GROUND - this.h;
            this.vy = 0; this.hang = 0; this.jumps = 1; this.hist = []; this.slide = 0;
        }
        draw() {
            let img = (state.mode === 'dying') ? assets.playerDead : (this.y < CFG.H - CFG.GROUND - this.h ? assets.playerJump : assets.playerIdle);
            if (state.mode === 'playing' && this.hist.length) {
                this.hist.forEach((pos, i) => {
                    ctx.globalAlpha = (i + 1) * (0.36 / this.hist.length);
                    if(pos.img.complete) ctx.drawImage(pos.img, pos.x * state.scaleX, pos.y * state.scaleY, this.w * state.scaleX, this.h * state.scaleY);
                });
                ctx.globalAlpha = 1.0;
            }
            if(img.complete) ctx.drawImage(img, this.x * state.scaleX, this.y * state.scaleY, this.w * state.scaleX, this.h * state.scaleY);
        }
        update(dt) {
            const gY = CFG.H - CFG.GROUND - this.h;
            if (state.mode === 'playing') {
                const img = (this.y < gY) ? assets.playerJump : assets.playerIdle;
                this.hist.push({x: this.x, y: this.y, img});
                if(this.hist.length > CFG.TRAIL) this.hist.shift();

                this.vy += CFG.GRAVITY * dt * 60;
                if (state.inputHeld && this.vy > 0 && this.hang < CFG.HANG) {
                    this.vy -= CFG.GRAVITY * CFG.GLIDE * dt * 60;
                    this.hang += dt;
                }
                this.y += this.vy * dt * 60;
                if (this.y > gY) {
                    this.y = gY; this.vy = 0; this.hang = 0;
                    this.jumps = state.doubleJump ? 2 : 1;
                }
            } else if (state.mode === 'dying') {
                if (this.y < gY) {
                    this.vy += CFG.GRAVITY * dt * 60;
                    this.y += this.vy * dt * 60;
                    if(this.y > gY) { this.y = gY; this.vy = 0; }
                }
                this.x += this.slide * dt * 60;
                this.slide *= CFG.FRICTION;
            }
        }
        jump() { if (this.jumps > 0) { this.vy = CFG.JUMP; this.hang = 0; this.jumps--; } }
        pound() { if (this.y < CFG.H - CFG.GROUND - this.h - 20) { this.vy = CFG.POUND; this.hang = CFG.HANG; } }
    }

    class Obstacle {
        constructor() {
            this.img = assets.obstacles[Math.floor(Math.random() * assets.obstacles.length)];
            let h = CFG.SIZES.ROCK_MIN + Math.random() * (CFG.SIZES.ROCK_MAX - CFG.SIZES.ROCK_MIN);
            if (this.img.obstacleType === 'car') h = CFG.SIZES.CAR;
            else if (this.img.obstacleType === 'dumpster') h = CFG.SIZES.DUMP;
            else if (this.img.obstacleType === 'cone') h = CFG.SIZES.CONE;
            
            const r = (this.img.complete && this.img.naturalWidth) ? this.img.naturalHeight / this.img.naturalWidth : 1;
            this.h = h; this.w = r > 0 ? h / r : h;
            this.x = CFG.W; this.y = CFG.H - CFG.GROUND - this.h;
        }
        draw() {
            if(this.img.complete) ctx.drawImage(this.img, this.x * state.scaleX, this.y * state.scaleY, this.w * state.scaleX, this.h * state.scaleY);
        }
        update(dt) { if (state.mode === 'playing') this.x -= state.speed * dt; }
    }

    class Ground {
        constructor() { this.x = 0; }
        update(dt) { if (state.mode === 'playing') this.x -= state.speed * dt; }
        draw() {
            const h = CFG.GROUND * state.scaleY, y = canvas.height - h;
            if (assets.road.complete && assets.road.height) {
                const w = h * (assets.road.width / assets.road.height);
                const sx = (this.x * state.scaleX) % w;
                for (let i = 0; (i * w) + sx < canvas.width; i++) ctx.drawImage(assets.road, sx + i * w - 1, y, w + 2, h);
            } else { ctx.fillStyle = '#111827'; ctx.fillRect(0, y, canvas.width, h); }
        }
    }

    // 5. FUNCTIONS
    function resize() {
        const c = get('game-container');
        if (!c) return;
        canvas.width = c.clientWidth; canvas.height = c.clientHeight;
        state.scaleY = canvas.height / CFG.H; state.scaleX = state.scaleY;
        if (state.mode === 'waiting') drawScene();
    }

    function init() {
        state.mode = 'playing'; state.score = 0; state.lastScore = -1;
        state.speed = CFG.SPEED; state.nextSpeed = CFG.MILESTONE;
        state.timer = 0; state.doubleJump = false;
        obstacles = []; looseBoard = null;
        player = new Player(); clouds = { x:0, draw: function() { 
            const w = CFG.W*2, sw = w*state.scaleX, sh = (assets.cloud.height/assets.cloud.width)*sw; 
            ctx.drawImage(assets.cloud, this.x*state.scaleX, 0, sw, sh);
            ctx.drawImage(assets.cloud, (this.x+w)*state.scaleX, 0, sw, sh);
        }, update: function(dt) { this.x -= 10*dt; if(this.x < -CFG.W*2) this.x = 0; }};
        ground = new Ground();
        
        [UI.startOverlay, UI.gameOverModal, UI.cryingFrog].forEach(el => { if(el) el.style.display = 'none'; });
        if (UI.cryingFrog) UI.cryingFrog.classList.remove('shake');
        
        if (UI.music) { UI.music.volume = 0.65; UI.music.muted = state.muted; UI.soundBtn.textContent = state.muted ? '🔇' : '🔊'; }
        if (UI.mainContainer && UI.fullScreenContainer && !document.fullscreenEnabled) UI.fullScreenContainer.style.display = 'none';

        updateScore(0);
        state.lastTime = performance.now();
        requestAnimationFrame(loop);
    }

    function updateScore(v) {
        const t = `Score: ${v}`;
        if(UI.mobileScore) UI.mobileScore.textContent = t;
        if(UI.desktopScore) UI.desktopScore.textContent = t;
    }

    function loop(now) {
        if (state.mode === 'over') return;
        const dt = (now - state.lastTime) / 1000;
        state.lastTime = now;
        if (isNaN(dt) || dt > 0.1) { requestAnimationFrame(loop); return; }

        ctx.clearRect(0, 0, canvas.width, canvas.height);
        clouds.update(dt); clouds.draw();
        ground.update(dt); ground.draw();

        if (state.mode === 'playing') {
            state.score += dt * 10;
            const fs = Math.floor(state.score);
            if (fs !== state.lastScore) { updateScore(fs); state.lastScore = fs; }
            
            if (state.score > state.nextSpeed) { state.speed += CFG.SPEED_INC; state.nextSpeed += CFG.MILESTONE; }
            
            if (!state.doubleJump && state.score >= CFG.UNLOCK) {
                state.doubleJump = true; player.jumps = 2;
                if(UI.unlockMsg) { UI.unlockMsg.style.display = 'flex'; UI.unlockMsg.classList.add('unlock-animation'); setTimeout(() => UI.unlockMsg.style.display = 'none', 2500); }
            }

            player.update(dt);
            state.timer -= state.speed * dt;
            if (state.timer <= 0) {
                obstacles.push(new Obstacle());
                state.timer = Math.random() * (CFG.MAX_GAP - CFG.MIN_GAP) + CFG.MIN_GAP;
            }

            // Collision
            const p = { x: player.x + player.w*CFG.HITBOX, y: player.y + player.h*CFG.HITBOX, w: player.w*(1-CFG.HITBOX*2), h: player.h*(1-CFG.HITBOX*2) };
            for (const o of obstacles) {
                const obs = { x: o.x + o.w*CFG.HITBOX, y: o.y + o.h*CFG.HITBOX, w: o.w*(1-CFG.HITBOX*2), h: o.h*(1-CFG.HITBOX*2) };
                if (p.x < obs.x + obs.w && p.x + p.w > obs.x && p.y < obs.y + obs.h && p.h + p.y > obs.y) {
                    state.mode = 'dying';
                    if(UI.music) { UI.music.pause(); UI.music.currentTime = 0; }
                    player.slide = 12; looseBoard = new Skateboard(player.x, player.y + 40);
                }
            }
        } else if (state.mode === 'dying') {
            player.update(dt);
            if (looseBoard) { looseBoard.update(dt); looseBoard.draw(); }
            if (Math.abs(player.slide) < 0.5) showGameOver();
        }

        player.draw();
        obstacles.forEach((o, i) => { o.update(dt); o.draw(); if(o.x < -o.w) obstacles.splice(i, 1); });
        requestAnimationFrame(loop);
    }

    function showGameOver() {
        state.mode = 'over';
        if(UI.finalScore) UI.finalScore.textContent = Math.floor(state.score);
        if(UI.gameOverModal) UI.gameOverModal.style.display = 'flex';
        if(UI.cryingFrog) { UI.cryingFrog.style.display = 'block'; UI.cryingFrog.classList.add('shake'); }
    }

    function drawScene() {
        ctx.clearRect(0,0,canvas.width, canvas.height);
        if(clouds) clouds.draw();
        if(ground) ground.draw();
        if(player) { player.y = CFG.H - CFG.GROUND - player.h; player.draw(); }
    }

    // 6. INPUTS
    function inputDown(e) {
        if (e.type === 'keydown' && e.code === 'ArrowDown') { e.preventDefault(); if(state.mode === 'playing') player.pound(); return; }
        if (e.cancelable && e.type !== 'mousedown') e.preventDefault();
        if (state.actionTaken) return;
        if (state.mode === 'playing') player.jump();
        state.inputHeld = true; state.actionTaken = true;
    }
    function inputUp(e) {
        if (e && e.cancelable && e.type !== 'mouseup') e.preventDefault();
        const touchEnd = e.changedTouches ? e.changedTouches[0].clientY : 0;
        if (touchEnd - state.touchY > 30 && state.mode === 'playing') player.pound();
        state.inputHeld = false; state.actionTaken = false;
    }

    // 7. SETUP
    window.addEventListener('resize', resize);
    document.body.onkeydown = (e) => {
        if (document.activeElement === UI.nameInput) return;
        if (e.code === 'Space') { e.preventDefault(); state.mode === 'waiting' ? (UI.startOverlay && UI.startOverlay.click()) : inputDown(e); }
        else if (e.code === 'ArrowDown') inputDown(e);
    };
    document.body.onkeyup = (e) => { if (e.code === 'Space') inputUp(e); };
    
    canvas.addEventListener('mousedown', inputDown);
    canvas.addEventListener('mouseup', inputUp);
    canvas.addEventListener('touchstart', (e) => { if(e.cancelable) e.preventDefault(); state.touchY = e.touches[0].clientY; inputDown(e); }, {passive: false});
    canvas.addEventListener('touchmove', (e) => { if(e.cancelable) e.preventDefault(); }, {passive: false});
    canvas.addEventListener('touchend', inputUp, {passive: false});

    if (UI.restartBtn) UI.restartBtn.onclick = () => {
        UI.gameOverModal.style.display = 'none';
        if(UI.cryingFrog) { UI.cryingFrog.style.display = 'none'; UI.cryingFrog.classList.remove('shake'); }
        if(UI.startOverlay) { UI.startOverlay.style.display = 'flex'; UI.startOverlay.addEventListener('click', startGame, {once:true}); }
        state.mode = 'waiting';
        player = new Player(); ground = new Ground(); resize();
    };

    if (UI.submitBtn) UI.submitBtn.onclick = () => {
        const val = UI.nameInput.value.trim();
        if (val && window.saveScore) {
            window.saveScore(val, Math.floor(state.score));
            UI.submitBtn.textContent = 'Submitted!'; UI.submitBtn.disabled = true;
            setTimeout(() => { UI.submitBtn.textContent = 'Submit'; UI.submitBtn.disabled = false; UI.nameInput.value = ''; UI.restartBtn.click(); }, 1000);
        }
    };

    if (UI.fullScreenBtn) UI.fullScreenBtn.onclick = () => {
        if (!document.fullscreenElement) {
            UI.mainContainer.requestFullscreen().then(() => { if(screen.orientation) screen.orientation.lock('landscape').catch(()=>{}); });
        } else document.exitFullscreen();
    };
    document.addEventListener('fullscreenchange', () => UI.fullScreenBtn.textContent = document.fullscreenElement ? 'Exit Fullscreen' : 'Fullscreen');
    
    if (UI.closeGameOver) UI.closeGameOver.onclick = () => UI.restartBtn.click();
    if (UI.soundBtn && UI.music) UI.soundBtn.onclick = (e) => { e.stopPropagation(); state.muted = !state.muted; UI.music.muted = state.muted; UI.soundBtn.textContent = state.muted ? '🔇' : '🔊'; };
    if (UI.helpBtn && UI.helpModal) {
        UI.helpBtn.onclick = (e) => { e.stopPropagation(); UI.helpModal.style.display = 'flex'; };
        UI.closeHelp.onclick = (e) => { e.stopPropagation(); UI.helpModal.style.display = 'none'; };
    }

    function startGame() {
        if (UI.music) UI.music.play().catch(()=>{});
        init();
    }

    const imgs = [assets.playerIdle, assets.playerJump, assets.playerDead, assets.board, assets.cloud, assets.road, ...assets.obstacles];
    const loadAll = () => Promise.all(imgs.map(i => new Promise(r => { i.onload = r; i.onerror = r; i.src = i.src; })));
    
    const safety = setTimeout(() => { console.warn("Forcing start"); setupGame(); }, 2000);
    
    function setupGame() {
        clearTimeout(safety);
        player = new Player(); ground = new Ground(); clouds = { x:0, draw:()=>{}, update:()=>{} }; // Temp objs
        resize();
        if(UI.startText) UI.startText.textContent = 'Tap to Start';
        if(UI.startOverlay) UI.startOverlay.addEventListener('click', startGame, {once: true});
    }

    loadAll().then(setupGame);

})();